import html from '../components/Tech/html.png';
import css from '../components/Tech/css.png';
import javascript from '../components/Tech/javascript.png';
import typescript from '../components/Tech/typescript.png';
import reactjs from '../components/Tech/reactjs.png';
import redux from '../components/Tech/redux.png';
import tailwind from '../components/Tech/tailwind.png';
import nodejs from '../components/Tech/nodejs.png';
import mongodb from '../components/Tech/mongodb.png';
import threejs from '../components/Tech/threejs.svg';
import git from '../components/Tech/git.png';
import figma from '../components/Tech/figma.png';
import docker from '../components/Tech/docker.png';

export const Bio = {
  name: "Aniket Vyavhare",
  location: "Pune, India",
  roles: [
    "Full-Stack Software Developer",
    "Frontend Developer",
    "Backend Developer",
    "AI/ML Developer",
  ],
  headline:
    "Full-Stack Software Developer (Angular, TypeScript, Django, PHP, AI/ML), around 1 year of industry experience across two internships.",
  description:
    "Full-Stack Software Developer (Angular, TypeScript, Django, PHP, AI/ML), around 1 year of industry experience across two internships.",

  email: "aniket.22420158@viit.ac.in",
  github: "https://github.com/am-vyavhare",
  linkedin: "https://linkedin.com/in/am-vyavhare",
  insta: "https://www.instagram.com/am_vyavhare/",
  resume: "https://drive.google.com/file/d/1612X8LGMOTsDHOa_45bLP0cI3dm3TYpj/view?usp=sharing",
  heroImage: process.env.PUBLIC_URL + "/HeroImage.png",
};

export const skills = [
  {
    title: "Languages",
    skills: [
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "JavaScript",
        image: javascript,
      },
      {
        name: "TypeScript",
        image: typescript,
      },
      {
        name: "Java",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "C",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
      },
      {
        name: "C++",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "C#",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
      },
      {
        name: "SQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
      },
      {
        name: "PHP",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "Angular",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
      },
      {
        name: "TypeScript",
        image: typescript,
      },
      {
        name: "React",
        image: reactjs,
      },
      {
        name: "NgRx",
        image: redux,
      },
      {
        name: "ECharts",
        image: "https://echarts.apache.org/en/images/favicon.png",
      },
      {
        name: "HTML",
        image: html,
      },
      {
        name: "CSS",
        image: css,
      },
      {
        name: "Bootstrap",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
      },
      {
        name: "Responsive Design",
        image: tailwind,
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Django",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/django/django-plain.svg",
      },
      {
        name: "Node.js",
        image: nodejs,
      },
      {
        name: "Express.js",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg",
      },
      {
        name: "PHP",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
      {
        name: "REST APIs",
        image: "https://img.icons8.com/?size=100&id=EPbEfEa7o8CB&format=png&color=000000",
      },
    ],
  },
  {
    title: "AI / ML",
    skills: [
      {
        name: "Machine Learning",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "TensorFlow",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "YOLOv5",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/opencv/opencv-original.svg",
      },
      {
        name: "OpenCV",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/opencv/opencv-original.svg",
      },
      {
        name: "LLM API Integration",
        image: threejs,
      },
    ],
  },
  {
    title: "Databases & Tools",
    skills: [
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image: mongodb,
      },
      {
        name: "Redis",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Git",
        image: git,
      },
      {
        name: "GitHub",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original.svg",
      },
      {
        name: "Docker",
        image: docker,
      },
      {
        name: "RabbitMQ",
        image: "https://www.vectorlogo.zone/logos/rabbitmq/rabbitmq-icon.svg",
      },
      {
        name: "Jira",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/jira/jira-original.svg",
      },
      {
        name: "Linux",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
      },
      {
        name: "Power BI",
        image: figma,
      },
    ],
  },
  {
    title: "Cloud / DevOps",
    skills: [
      {
        name: "AWS (EC2, S3, IAM, VPC, RDS)",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Docker",
        image: docker,
      },
      {
        name: "Cloud Computing Fundamentals",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg",
      },
    ],
  },
  {
    title: "Practices",
    skills: [
      {
        name: "Debugging",
        image: git,
      },
      {
        name: "Software Testing",
        image: docker,
      },
      {
        name: "MVC Architecture",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
      {
        name: "Database Design",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
      },
      {
        name: "Internationalization (i18n)",
        image: threejs,
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: require("../images/itanta_logo.jpg"),
    role: "Trainee Software Engineer",
    company: "Itanta Analytics, Pune",
    date: "Jun 2026 - Nov 2026",
    bullets: [
      "Resolved 50+ Jira feature and bug tickets on a production industrial analytics dashboard platform using Angular, TypeScript, NgRx and ECharts, with root cause analysis.",
      "Implemented internationalization (i18n) for 17 languages using Transloco, with per-user language persistence and server-side message translation.",
      "Built a communication-loss alarm feature (UI and write-back), validated across 8 data source connectors.",
      "Fixed PDF and Excel export defects across frontend and backend renderers.",
      "Fixed VAPT security findings (CORS allow-list, cipher settings, input validation); built frontend and API integration for a VAPT platform.",
      "Added LLM-based output type detection for formula validation; tested Windows and Linux (Docker) builds.",
    ],
    skills: [
      "Angular",
      "TypeScript",
      "NgRx",
      "ECharts",
      "Transloco (i18n)",
      "Docker",
      "REST APIs",
      "VAPT Security",
    ],
  },
  {
    id: 1,
    img: require("../images/deeper_logo.png"),
    role: "Software Developer Intern",
    company: "Deeper (exam preparation platform), Pune (Hybrid)",
    date: "Jul 2025 - Dec 2025",
    bullets: [
      "Developed features on a live PHP (MVC) and MySQL platform serving 5000+ student accounts across 12 exam packages.",
      "Designed a junction table and migrated data using database normalization for multi-package exams, supporting around 50 mock exams.",
      "Built role-based dashboards, responsive package cards, Excel upload and privacy-safe export endpoints.",
    ],
    skills: [
      "PHP (MVC)",
      "MySQL",
      "Database Normalization",
      "Role-Based Dashboards",
      "Excel Data Pipelines",
    ],
  },
  {
    id: 2,
    img: require("../images/heuristic_technopark_logo.jpeg"),
    role: "Python Developer Intern (Django)",
    company: "Heuristic Technopark, Nashik",
    date: "Jun 2023 - Aug 2023",
    bullets: [
      "Built modular Django apps; managed 500+ records using Django ORM.",
      "Built an LLM chatbot for healthcare, education and finance with keyword-based filtering.",
    ],
    skills: [
      "Django",
      "Python",
      "Django ORM",
      "LLM Chatbot",
      "REST APIs",
    ],
  },
];

export const projects = [
  {
    id: 0,
    title: "Bug Classification and Severity Prediction (Industry-Sponsored Project)",
    date: "Jun 2025 - Nov 2025",
    description:
      "Built a Jira-integrated system that classifies bugs and predicts severity using ML, exposed via REST APIs.",
    img: require("../images/BugClassification_Project.png"),
    tags: ["Jira", "Machine Learning", "REST APIs", "Python", "NLP"],
    category: "machine learning",
    github: "https://github.com/am-vyavhare/Bug-Classification-and-Severity-Prediction",
    webapp: "",
    featured: true,
  },
  {
    id: 1,
    title: "GrowGenius",
    date: "March 2025 - May 2025",
    description:
      "ML agriculture platform for crop prediction, disease detection and fertilizer recommendation, 80%+ model accuracy.",
    img: require("../images/GrowGenius_Project.png"),
    tags: [
      "React",
      "Django",
      "TensorFlow",
      "Firebase",
      "Machine Learning",
      "OpenCV",
    ],
    category: "web app",
    github: "https://github.com/am-vyavhare/GrowGenius_Showcase",
    webapp: "",
  },
  {
    id: 2,
    title: "DigitalDetox",
    date: "March 2025 - April 2025",
    description:
      "Developed a Kotlin-based app using Jetpack Compose, reducing daily screen time by up to 35% during testing. Integrated Firebase for user data management and progress tracking across 100+ sessions with zero sync failures. Designed focus mode, breathing tools, and gamified challenges, improving app engagement by 60% in user testing.",
    img: require("../images/DigitalDetox_Project.jpg"),
    tags: ["Kotlin", "Android Development", "Firebase", "UI/UX", "Responsive"],
    category: "android app",
    github: "https://github.com/am-vyavhare/DigitalDetox_Showcase",
    webapp: "",
  },
  {
    id: 3,
    title: "SharedGo",
    date: "March 2025 - April 2025",
    description:
      "Engineered a Flutter-based app with AI ride-matching that reduced user wait time by 50%. Leveraged Firebase for real-time updates, handling 100+ concurrent users during testing. Mapped over 100 test routes using OpenStreetMap for dynamic driver-passenger coordination.",
    img: require("../images/SharedGo_Project.png"),
    tags: [
      "Flutter",
      "Blockchain",
      "Artificial Intelligence",
      "Firebase",
      "App Development",
    ],
    category: "android app",
    github: "https://github.com/am-vyavhare/SharedGo-showcase",
    webapp: "",
  },
  {
    id: 4,
    title: "SkyWatch",
    date: "November 2024 - December 2024",
    description:
      "Real-time airborne object detection with SMS alerts to 100+ soldiers via Twilio.",
    img: require("../images/SkyWatch_Project.png"),
    tags: ["Django", "Twilio", "SQLite3", "YOLOv5", "Python", "Computer Vision"],
    category: "machine learning",
    github: "https://github.com/am-vyavhare/SkyWatch_Showcase",
    webapp: "",
  },
];

export const publications = [
  {
    id: 0,
    title: "Applying ML to Identify Optimal Locations for Wind Energy Generation",
    conference: "IEEE APCIT 2025",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11411535",
    desc: "Research paper on utilizing machine learning models to identify optimal geographic locations for wind energy harness with data-driven predictive analysis.",
  },
  {
    id: 1,
    title: "RapidGrade: OCR & NLP-based Automated Assessment",
    conference: "IEEE PUNECON 2025",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11378891",
    desc: "Published IEEE research introducing automated assessment for handwritten student evaluation leveraging Optical Character Recognition (OCR) and Natural Language Processing (NLP).",
  },
];

export const achievements = [
  {
    id: 0,
    title: "Finalist at GeekVishwa 2.0",
    detail: "National Level Hackathon",
    desc: "Selected as finalist in a competitive national-level engineering hackathon competing with top university teams.",
  },
  {
    id: 1,
    title: "2nd Runner-Up in State-Level C Programming Quiz",
    detail: "State Competition",
    desc: "Secured 3rd place statewide in deep programming concepts, logic evaluation, and algorithms quiz.",
  },
  {
    id: 2,
    title: "Technical Executive, I2IC Club",
    detail: "Aug 2024 - Jun 2025",
    desc: "Assisted in organizing technical workshops, hackathons, and industry-focused events at VIIT Pune.",
  },
];

export const education = [
  {
    id: 0,
    img: require("../images/viit_logo.jpeg"),
    school: "BRACT's, Vishwakarma Institute of Information Technology, Pune",
    date: "Jun 2024 - Jun 2027 (Ongoing)",
    grade: "9.19 CGPA",
    desc: "Pursuing Bachelor of Technology in Information Technology with consistent academic record and focus on engineering excellence.",
    degree: "Bachelor of Technology - B.Tech, Information Technology",
  },
  {
    id: 1,
    img: require("../images/gpj_logo.png"),
    school: "Government Polytechnic, Jalgaon",
    date: "Jun 2021 - Jun 2024",
    grade: "90.34%",
    desc: "Served as Class Representative for 3 years, leading 100+ students. Built strong foundations in computer engineering, data structures, and leadership.",
    degree: "Diploma in Computer Engineering",
  },
  {
    id: 2,
    img: require("../images/maharana_logo.png"),
    school: "Maharana Pratap Vidyalaya, Bhusawal",
    date: "Jun 2015 - Jun 2021",
    grade: "99.40%",
    desc: "Completed class 10 (SSC) with 99.40%, consistently performing at the top of the class.",
    degree: "10th SSC",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];

export const technologies = [
  { name: "HTML 5", icon: html },
  { name: "CSS 3", icon: css },
  { name: "JavaScript", icon: javascript },
  { name: "TypeScript", icon: typescript },
  { name: "React JS", icon: reactjs },
  { name: "Redux Toolkit", icon: redux },
  { name: "Tailwind CSS", icon: tailwind },
  { name: "Node JS", icon: nodejs },
  { name: "MongoDB", icon: mongodb },
  { name: "Three JS", icon: threejs },
  { name: "git", icon: git },
  { name: "figma", icon: figma },
  { name: "docker", icon: docker },
];
